
export abstract class IDataComparable {
  /**
   * Does a deep check(goes down the nesting tree and checks all fields)
   * between two data model instances and returns {@link true} if both contains the same data.
   */
   abstract isSame(other: this): boolean
}
